import { render, staticRenderFns } from "./DashTickets.vue?vue&type=template&id=42cd097a&scoped=true"
import script from "./DashTickets.vue?vue&type=script&lang=js"
export * from "./DashTickets.vue?vue&type=script&lang=js"
import style0 from "./DashTickets.vue?vue&type=style&index=0&id=42cd097a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cd097a",
  null
  
)

export default component.exports